var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 9.53978 2.8731 9.16669 3.33333 9.16669H16.6667C17.1269 9.16669 17.5 9.53978 17.5 10C17.5 10.4603 17.1269 10.8334 16.6667 10.8334H3.33333C2.8731 10.8334 2.5 10.4603 2.5 10Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusFilled);
export default __webpack_public_path__ + "static/media/minus_filled.84a96147c96e8e36e0d818413a4dfaca.svg";
export { ForwardRef as ReactComponent };